import { GameState, ItemType } from '../types';
import { RECIPES } from '../data/recipes';
import { playCoinSound } from '../audio';

export function canCraft(state: GameState, recipeId: ItemType): boolean {
  const recipe = RECIPES.find(r => r.id === recipeId);
  if (!recipe) return false;
  return state.player.wood >= recipe.woodCost && state.player.coins >= recipe.coinCost;
}

export function craftItem(state: GameState, recipeId: ItemType): boolean {
  const recipe = RECIPES.find(r => r.id === recipeId);
  if (!recipe) return false;
  if (!canCraft(state, recipeId)) return false;

  state.player.wood -= recipe.woodCost;
  state.player.coins -= recipe.coinCost;

  switch (recipeId) {
    case ItemType.Spear:
      state.player.spears += 3; // craft gives 3 spears
      break;
    case ItemType.SuperAxe:
      state.player.hasSuperAxe = true;
      break;
  }

  playCoinSound();
  return true;
}
